/**
 * SampleLibraryWrapper Component
 * Wrapper for Sample Library Browser with track integration logic
 */

import React from 'react';
import { SampleLibraryBrowser } from '../samples';
import { toast } from 'sonner';

export const SampleLibraryWrapper = ({
  isOpen,
  onClose,
  audioContext,
  tracks,
  currentTime,
  setTracks,
  TRACK_COLORS,
}) => {
  const handleInsertSample = (sample) => {
    // Add sample to first audio track or create new one
    const audioTrack = tracks.find(t => t.type === 'audio');
    
    if (audioTrack) {
      toast.success(`Added "${sample.name}" to ${audioTrack.name}`);
    } else {
      const newTrack = {
        id: `track-${Date.now()}`,
        name: `Samples`,
        type: 'audio',
        volume: 0.8,
        pan: 0,
        mute: false,
        solo: false,
        armed: false,
        color: TRACK_COLORS[tracks.length % TRACK_COLORS.length],
        clips: [{
          id: `clip-${Date.now()}`,
          name: sample.name,
          startTime: currentTime,
          duration: sample.duration || 4,
        }],
      };
      setTracks(prev => [...prev, newTrack]);
      toast.success(`Created new track with "${sample.name}"`);
    }
  };

  return (
    <SampleLibraryBrowser
      isOpen={isOpen}
      onClose={onClose}
      audioContext={audioContext}
      onInsertSample={handleInsertSample}
    />
  );
};

export default SampleLibraryWrapper;
